import { propertyQueryKeys as e } from "./usePropertiesQueryKeys.mjs";
import { useMutation as t, useQueryClient as n } from "@maat/store-hooks";
import { propertiesApi as r } from "@maat/api-main";
//#region src/properties/useUpdateListingPricingMutation.ts
var i = () => {
	let i = n();
	return t({
		mutationFn: ({ propertyId: e, ...t }) => r.patchPropertyPricing(e, t),
		onSuccess: (t, { propertyId: n }) => {
			i.invalidateQueries({ queryKey: e.property(n) }), i.invalidateQueries({ queryKey: e.hostFeed() });
		}
	});
};
//#endregion
export { i as useUpdateListingPricingMutation };
